import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import propertyService from '../../service/property.service';
import { FieldType } from '../../config/property';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';

const PropertyReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    propertyService.properties(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      type: 'string',
      headerName: 'Megnevezés',
    },
    {
      field: 'type',
      type: 'singleSelect',
      valueOptions: FieldType,
      headerName: 'Típus',
      renderCell: (params) => {
        const fieldType = FieldType.find((field) => field.value === params.value);
        return fieldType ? fieldType.label : params.value;
      },
    },
    {
      field: 'formName',
      type: 'string',
      headerName: 'Felületek',
      renderCell: (params) => {
        const forms = params.row.formProperty
          ?.map((form) => form.submenus?.subMenuName)
          .filter(Boolean)
          .join(', ');

        return forms || '';
      },
    },
    {
      field: 'visOrder',
      type: 'number',
      headerName: 'Sorrend',
      filterable: false,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.PropertyReports}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={columns}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default PropertyReports;
